<!--Loading display-->
<div class="col-12 d-flex justify-content-center align-items-center" style="min-height: 50px" *ngIf="busy">
  <span *ngIf="!!busyText" class="m-1 p-1">{{ busyText }}</span>
  <div class="spinner-grow text-primary m-1" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
